<template>
  <div id="ServiceTerm">
    <h1 class="mb-5 text-center">서비스 이용약관</h1>
    <p style="text-indent: 0pt">
      <br />
    </p>
    <h3 style="text-indent: 0pt">
      제1조(목적)
      <span class="p"
        >이 약관은 주식회사 펀다에이아이(이하 “회사”라 합니다)가 운영하는 인터넷 사이트(이하 “사이트”라
        합니다)에서 제공하는 모든 웹서비스(이하 “서비스”라 합니다)의 이용절차 등 필요한 사항을
        규정함을 목적으로 합니다.</span
      >
    </h3>
    <p style="text-indent: 0pt">
      <br />
    </p>
    <h3 style="text-indent: 0pt">
      제2조(용어의 정의)
      <span class="p">① 이 약관에서 사용하는 용어의 정의는 다음 각 호와 같 습니다.</span>
    </h3>
    <ol id="l1">
      <li data-list-text="1.">
        <p style="padding-top: 2pt; text-indent: 0pt">
          <a href="http://www.funda.kr/" class="a" target="_blank"
            >“사이트”란 회사가 인터넷을 통해 상품 및 서비스를 제공하는 웹사이 트 중 웹브라우저
            주소창에 “www.funda.k</a
          >r”을 입력하였을 때 웹브라우 저 화면에 표시되는 페이지로 그에 부속된 웹페이지를 포함하며,
          컴퓨터 등 정보통신설비를 이용하여 제공할 수 있도록 설정한 가상의 영업장 또 는 서비스
          공간을 말합니다. 아울러 사이트를 운영하는 사업자의 의미로도 사용됩니다.
        </p>
      </li>
      <li data-list-text="2.">
        <p style="text-indent: 0pt">
          “서비스”란 회사의 홈페이지 및 회사가 직접 운영하는 사이트 등에서 제공하는 인터넷상의 모든
          서비스를 말합니다.
        </p>
      </li>
      <li data-list-text="3.">
        <p style="text-indent: 0pt">
          “이용자”란 홈페이지에 접속하여 이 약관에 따라 회사가 제공하는 서 비스를 받는 회원을
          말합니다.
        </p>
      </li>
      <li data-list-text="4.">
        <p style="text-indent: 0pt">
          &quot;회원&quot;이란 이 약관에 동의하고 회사가 운영하는 사이트에서 서비스를 제공받는 자를
          말합니다. 회사가 제시하는 정책에 의해 회원의 등급을 구 분하여 서비스 이용범위나 혜택 또는
          서비스 사용료 징수 등을 다르게 적 용할 수 있습니다.
        </p>
      </li>
      <li data-list-text="5.">
        <p style="text-indent: 0pt">
          “투자자”란 사이트에 공시된 채권에 대해 투자신청을 한 회원을 말합 니다.
        </p>
      </li>
      <li data-list-text="6.">
        <p style="text-indent: 0pt">
          “차입자”란 자금을 빌릴 의사가 있는 자로써 온라인으로 제공하는 양 식에 맞춰 대출신청을 한
          회원을 말합니다.
        </p>
      </li>
      <li data-list-text="7.">
        <p style="text-indent: 0pt">
          “ID”란 회원으로 로그인하기 위해 회원가입 시 등록한 E-mail 또는 회 원식별과 회원의 서비스
          이용을 위하여 회원 본인이 설정하고 회사가 승인 하는 영문, 숫자, 영문과 숫자의 혼합 등으로
          표기된 인식문자를 말합니다.
        </p>
      </li>
      <li data-list-text="8.">
        <p style="text-indent: 0pt">
          &quot;PASSWORD&quot;라 함은 회원의 비밀보호 및 회원 본인임을 확인하고 서 비스에 제공되는
          각종 정보의 보안을 위해 회원 자신이 설정하며 회사가
        </p>
      </li>
    </ol>
    <p style="padding-top: 2pt; text-indent: 0pt">
      승인하는 문자, 숫자 그리고 특수문자의 조합을 말합니다.
    </p>
    <p style="padding-top: 3pt; text-indent: 0pt">
      ② 이 약관에서 사용하는 용어 중 제1항에서 정하지 아니한 사항에 대하여 는 관계법령 및 서비스별
      안내에서 정하는 바에 따르며, 그 이외에는 일반 거래관행에 따릅니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제3조(서비스의 종류)
      <span class="p">① 회사가 회원에게 제공하는 서비스의 종류는 다음 각 호와 같습니다.</span>
    </h3>
    <ol id="l2">
      <li data-list-text="1.">
        <p
          style="
            padding-top: 2pt;

            text-indent: 0pt; ;
          "
        >
          “금융거래장소(Platform)”란 사이트를 통해 차입자가 회사로부터 대출 을 받기 위한 대출신청 및
          대출과 관련된 모든 활동, 그리고 투자자가 해 당 채권에 대한 투자실행 등 투자와 관련된 모든
          활동에 대하여 온라인으 로 제공되는 서비스 및 기타 부가서비스 일체를 말합니다.
        </p>
      </li>
      <li data-list-text="2.">
        <p style="text-indent: 0pt">
          “기타 서비스”란 회사의 금융거래장소(Platform) 서비스 이외에 회사의 사이트를 통해 제공되는
          홍보서비스 등 기타 서비스를 말합니다.
        </p>
      </li>
    </ol>
    <p style="text-indent: 0pt">
      ② 회사는 서비스 변경 시 그 변경되는 서비스의 내용 및 제공일자를 제18 조에서 정한 방법으로
      회원에게 통지하고 제1항에서 정한 서비스를 변경하 여 제공할 수 있습니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제4조(서비스 이용계약의 성립 등)
      <span class="p"
        >① 회사가 제공하는 서비스에 관한 이용 계약(이하 “이용계약”이라고 합니다)은 회원이 되고자
        하는 자가 이 약관 에 동의하고 정해진 가입양식에 회원정보(ID, PASSWORD, 기타 회사가 필요
        하다고 인정하는 사항 등)를 기입하면 회사가 이에 대하여 승낙함으로써 성 립됩니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 3pt;

        text-indent: 0pt; ;
      "
    >
      ② 회원에 가입하는 자는 회사가 요구하는 개인정보를 성실히 제공하여야 합니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 타인의 개인정보를 도용하여 허위가입한 회원은 회사가 제공하는 서비스 를 이용할 수 없으며,
      이에 따른 민<span class="s1">․</span>형사상의 모든 책임은 당해 회원에게 있 습니다.
    </p>
    <p style="text-indent: 0pt">
      ④ 회사는 회원정보(ID, PASSWORD, 기타 회사가 필요하다고 인정하는 사항 등)를 접수받아 이를
      관리합니다.
    </p>
    <p style="text-indent: 0pt">
      ⑤ 회사는 관계법령에 위배되지 않는 범위 내에서 이 약관을 개정할 수 있 으며, 이 약관을 개정할
      경우 회원에게 E-mail 또는 서면, SNS 등의 방법으 로 개정된 약관개정 내용을 회원에게 통지합니다.
      약관개정에 대한 회사의 통지 후 7일 이내에 의사표시를 하지 않은 회원은 개정된 약관에 동의한 것
      으로 간주됩니다.
    </p>
    <h3 style="text-indent: 0pt; line-height: 20pt">
      제5조(서비스 중단) <span class="p">① 회사는 긴급한 시스템 점검, 증설 및 교체 등 부득이</span>
    </h3>
    <p
      style="
        padding-top: 1pt;

        text-indent: 0pt; ;
      "
    >
      한 사유 발생 시 사전공지 없이 일시적으로 서비스를 중단할 수 있으며, 새 로운 서비스로의 교체 등
      회사가 적절하다고 판단하는 사유에 의해 현재 제 공되는 서비스를 완전히 중단할 수 있습니다.
    </p>
    <p style="text-indent: 0pt">
      ② 회사는 서비스 설비의 장애 또는 서비스 이용 폭주 등 회사의 귀책이 아 닌 사유로 정상적인
      서비스 제공이 불가능한 경우에는 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다. 단,
      이 경우 그 사유 및 기간 등을 회원에게 사전 또는 사후에 공지합니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 회사는 천재지변, 전쟁 등 불가항력적인 사유가 발생한 경우 또는 기간통 신사업자 등
      전기통신사업자가 전기통신서비스를 중지하거나 정상적으로 제 공하지 않는 경우에는 서비스를
      중단할 수 있습니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제6조(회원가입)
      <span class="p"
        >① 회원이 되고자 하는 자는 회사가 정한 방식에 따라 이 약관의 적용에 대한 동의의 의사표시를
        하고 사이트에서 정한 가입양식에 따라 회원정보를 기입하여 회원등록 신청을 하고 회사가
        승낙함으로서 성립 됩니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 3pt;

        text-indent: 0pt;
      "
    >
      ② 회사는 일부 사이트의 특정 서비스를 제공하기 위해 회원에게 별도 또는 추가적인 가입절차를
      요청할 수 있으며, 이러한 특정 서비스를 이용할 경우 해당 사이트 또는 서비스에 대한 이용약관,
      규정 또는 세칙 등이 이 약관보 다 우선 적용됩니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 회사는 회원이 사이트 및 서비스를 쉽게 이용할 수 있도록 회원의 ID를 포함한 회원정보를
      관리하거나 사이트 또는 서비스를 개선, 변경할 수 있습 니다.
    </p>
    <p style="text-indent: 0pt">
      ④ 회원은 회원가입 시 회사가 서비스를 제공함에 있어 필요로 하는 정보를 제공하여야 하며, 회사가
      특별히 요청할 경우에는 관련서류를 제출하여야 합 니다.
    </p>
    <p style="text-indent: 0pt">
      ⑤ 회원이 사실과 다른 정보 또는 허위정보를 기입하거나 추후 그러한 정보 임이 밝혀질 경우
      운영자의 권한으로 서비스 이용을 일시정지하거나 영구정 지 및 이용계약을 해지할 수 있습니다.
      이로 인해 회사 또는 제3자에게 발생 한 손해에 대하여는 당해 회원이 책임을 집니다. 단, 회사의
      고의 또는 과실 에 의해 손해가 발생한 경우에는 회사가 손해를 부담합니다.
    </p>
    <p style="text-indent: 0pt">
      ⑥ 회사는 회원이 가입 신청한 경우 관계법령에 따라 이용가능한 신용정보 업자 또는
      신용정보집중기관을 통해 본인 여부를 확인할 수 있으며, 회사는 실명확인절차를 취할 수 없는
      이용신청에 대하여는 신청자에게 증빙자료를
    </p>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt;
      "
    >
      요청할 수 있습니다.
    </p>
    <p
      style="
        padding-top: 3pt;

        text-indent: 0pt; ;
      "
    >
      ➀ 회사는 다음 각 호에 해당하는 사유가 있는 경우에는 회원가입 신청에 대한 승낙을 유보할 수
      있습니다. 이 경우 회사는 회원가입 신청자에게 승낙 유보의 사유, 승낙가능 시기 또는 승낙에
      필요한 추가요청 정보 내지 자료 등 기타 승낙유보와 관련된 사항을 해당 서비스화면에 게시하거나
      기타 방 법을 통해 회원에게 통지합니다.
    </p>
    <ol id="l3">
      <li data-list-text="1.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          설비에 여유가 없는 경우
        </p>
      </li>
      <li data-list-text="2.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          기술상 지장이 있는 경우
        </p>
      </li>
      <li data-list-text="3.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          기타 회사가 합리적인 판단에 의해 필요하다고 인정하는 경우
        </p>
      </li>
    </ol>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제7조(회원정보의 수집 및 보호)
      <span class="p"
        >① 회사는 원활한 이용계약을 위해 회원이 제공한 정보 이외에도 수집목적 또는 이용목적을 밝혀
        회원으로부터 필요한 정보를 수집할 수 있습니다. 이 경우 회사는 회원으로부터 정보수집에 대한
        동의를 받습니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 3pt;

        text-indent: 0pt; ;
      "
    >
      ② 회사가 정보수집을 위해 회원의 동의를 받는 경우, 회사는 수집하는 개인 정보의 항목 및
      수집방법, 수집목적 및 이용목적, 개인정보의 보유 및 이용 기간, 제3자에 대한
      정보제공사항(제공받는 자, 제공받는 자의 이용목적, 제 공정보의 항목, 보유 및 이용기간)을
      개인정보취급방침으로 미리 명시하거나 고지합니다. 회원은 정보제공에 동의하더라도 언제든지 그
      동의를 철회할 수 있습니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 회원은 회사에 해당 정보를 제공하고자 하는 경우 사실대로 제공하여야 합니다.
    </p>
    <p style="text-indent: 0pt">
      ④ 회사는 회원의 개인정보보호를 위하여 관리자를 최소한으로 한정하며, 회 사의 고의 또는 과실로
      인해 회원정보가 분실, 도난, 유출, 변조된 경우에는 그로 인한 회원의 손해에 대하여 책임을
      부담합니다.
    </p>
    <p style="text-indent: 0pt">
      ⑤ 회사는 관계법령에서 정하는 바에 따라 회원정보를 포함한 개인정보를 보호하기 위해 노력합니다.
      회원의 개인정보보호와 관련하여서는 관계법령 및 회사가 정하고 별도로 게시하는
      &quot;개인정보보호정책&quot;에서 정한 바에 준합 니다.
    </p>
    <p style="text-indent: 0pt">
      ⑥ 이용계약이 종료된 경우, 회사는 당해 회원의 정보를 파기하는 것을 원칙 으로 합니다. 단, 다음
      각 호에 해당하는 경우에는 회원정보를 보관합니다. 이 경우 회사는 보관하고 있는 회원정보를 그
      보관의 목적으로만 이용합니다.
    </p>
    <ol id="l4">
      <li data-list-text="1.">
        <p style="text-indent: 0pt">
          관계법령의 규정에 의거 보존할 필요가 있는 경우 회사는 관계법령에서 정한 일정기간 동안
          회원정보를 보관합니다.
        </p>
      </li>
      <li data-list-text="2.">
        <p style="padding-top: 2pt; text-indent: 0pt">
          회원탈퇴 신청 등으로 인해 이용계약이 종료된 경우, 회사는 투자자보 호 및 이 약관에서 정한
          제한을 의도적으로 회피하기 위한 임의해지 방지 를 위하여 상당하다고 인정되는 경우에 한해
          이용계약 종료 후 1년간 ID, 성명 또는 상호, 연락처, 거래 상세내역, 약관위반 행위자료 등
          최소한의 필요정보를 보관합니다.
        </p>
      </li>
      <li data-list-text="3.">
        <p style="text-indent: 0pt">
          회사가 이용계약을 해지하거나 회사로부터 회원자격 정지 조치를 받은 회원에 대해서는 재가입에
          대한 승낙거부 사유가 존재하는지 여부를 확인 하기 위한 목적으로 이용계약 종료 후 1년간 ID,
          성명 또는 상호, 연락처, 주소, 해지 및 회원자격 정지와 관련된 정보 등 최소한의 필요정보를
          보관 합니다.
        </p>
      </li>
      <li data-list-text="4.">
        <p style="text-indent: 0pt">
          기타 정보수집에 관한 동의를 받을 때 보유기간을 명시한 경우에는 그 보유기간까지 회원정보를
          보관합니다.
        </p>
      </li>
      <li data-list-text="5.">
        <p style="text-indent: 0pt">
          회사는 회원정보의 보호 및 관리에 관한 개인정보취급방침을 회 원과 회사의 서비스를
          이용하고자 하는 자가 알 수 있도록 사이트 (http://www.funda.kr)에 공지합니다.
        </p>
      </li>
    </ol>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제8조(회원의 의무)
      <span class="p">① 회원은 서비스 이용 시 다음 각 호의 행위를 하여서 는 아니됩니다.</span>
    </h3>
    <ol id="l5">
      <li data-list-text="1.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          회원가입 신청 시 기재항목에 허위사실을 기재하는 행위
        </p>
      </li>
      <li data-list-text="2.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          다른 회원의 ID 및 PASSWORD를 부정하게 이용하는 행위
        </p>
      </li>
      <li data-list-text="3.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          서비스를 이용하여 얻은 정보를 회원의 개인적인 이용 외에 복사, 가공, 번역, 2차적 저작 등을
          통해 복제, 공연, 방송, 전시, 배포, 출판 등에 이용 하거나 제3자에게 제공하는 행위
        </p>
      </li>
      <li data-list-text="4.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          타인이나 회사의 명예를 손상시키거나 불이익을 주는 행위
        </p>
      </li>
      <li data-list-text="5.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          회사의 저작권, 제3자의 저작권 등 권리를 침해하는 행위
        </p>
      </li>
      <li data-list-text="6.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 음성 등을 타인에게 유포하는 행위
        </p>
      </li>
      <li data-list-text="7.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          범죄와 결부된다고 객관적으로 인정되는 행위
        </p>
      </li>
      <li data-list-text="8.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          서비스와 관련된 설비의 오동작이나 정보 등의 파괴 및 혼란을 유발시 키는 컴퓨터 바이러스
          감염자료를 등록 또는 유포하는 행위
        </p>
      </li>
      <li data-list-text="9.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          서비스의 안정적 운영을 방해할 수 있는 정보를 전송하거나 수신자의 의사에 반하여 광고성
          정보를 전송하는 행위
        </p>
      </li>
      <li data-list-text="10.">
        <p style="padding-top: 3pt; text-indent: 0pt; text-align: justify">
          기타 관계법령에 위배되는 행위
        </p>
      </li>
    </ol>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt; ;
      "
    >
      ② ID 및 PASSWORD 관리에 관한 일체의 책임은 회원 본인에게 있습니다. 회원에게 부여된 ID 및
      PASSWORD를 제3자에게 대여 또는 양도하거나 이와 유사한 행위를 하여서는 아니되며, ID 및
      PASSWORD의 관리소홀, 부정이용 에 의해 발생하는 모든 결과에 대한 책임은 회원 본인에게 있습니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 회원은 자신의 ID가 부정하게 이용된 경우, 즉시 그 사실을 회사에 통보 하여야 합니다. 통보 전에
      발생하는 모든 결과에 대한 책임은 회원 본인에게 있습니다.
    </p>
    <p style="text-indent: 0pt">
      ④ 회원은 본인의 신상 관련 사항이 변경되었을 경우에는 가능한 방법으로 지체없이 회사에
      통보하여야 합니다. 통보 전에 발생하는 모든 결과에 대한 책임은 회원 본인에게 있습니다.
    </p>
    <p style="text-indent: 0pt">
      ⑤ 회원은 회사의 사전승낙 없이 서비스를 이용하여 영업활동을 할 수 없으 며, 그 영업활동으로 인한
      결과에 대해 회사는 책임을 지지 아니합니다.
    </p>
    <p style="text-indent: 0pt">
      ⑥ 회원은 이 약관 및 관계법령에서 규정한 사항과 서비스 이용안내 또는 주의사항을 성실히
      준수하여야 합니다.
    </p>
    <p style="text-indent: 0pt">
      ➀ 회원은 내용별로 회사가 서비스 공지사항에 게시하거나 별도로 공지한 이용제한 사항을 준수하여야
      합니다.
    </p>
    <p style="text-indent: 0pt">
      ⑧ 회원은 회사의 사전동의 없이 서비스의 이용권한, 기타 이용계약 상 지위 를 타인에게 양도 또는
      증여할 수 없으며, 이를 담보로 제공할 수 없습니다.
    </p>
    <p style="text-indent: 0pt">
      ⑨ 회원은 반드시 본인의 실명으로 등록하여야 하며, 타인의 명의를 도용하 는 경우 일체의 보호를
      받을 수 없으며, 관계법령에 의하여 처벌받을 수 있 습니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt; line-height: 114%">
      제9조(서비스 이용 권리의 양도 등)
      <span class="p"
        >① 회사의 사전동의 없이 서비스의 이용 권한, 기타 이용계약 상 지위를 타인에게 양도 또는
        증여할 수 없으며, 이를 담보로 제공할 수 없습니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 1pt;

        text-indent: 0pt; ;
      "
    >
      ② 회사는 보안 및 ID 정책, 서비스의 원활한 제공 등과 같은 이유로 제18조 의 방법으로 고지를 통해
      회원의 ID 변경을 요구하거나 변경할 수 있습니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제10조(계약해지 및 이용제한)
      <span class="p"
        >① 회사는 서비스 이용을 신청한 고객에 대해 내부평가에 따라 서비스 이용을 승낙합니다. 회원이
        이용계약을 해지하고자 할 경우에는 본인이 회사 홈페이지 또는 회사가 정한 별도의 방법을 이용하
        여 회사에 해지신청을 하여야 합니다. 이 경우 회사는 소정의 해지절차를 거 쳐 해지를 요청한
        회원의 정보는 “개인정보취급방침”에 따라 처리하며 이 용계약은 회사가 회원의 해지신청을
        승낙하였을 때에 종료됩니다. 본 항에</span
      >
    </h3>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt; ;
      "
    >
      따라 계약해지 한 회원은 이 약관이 정하는 회원가입 절차와 관련 조항에 따라 다시 회원으로 가입할
      수 있습니다.
    </p>
    <p style="text-indent: 0pt">
      ② 회사는 서비스 이용신청이 다음 각 호에 해당하는 것으로 판단되거나 서 비스 이용신청 이후의
      상황이 다음 각 호의 하나에 해당하는 것으로 판단되 는 경우에는 이용승낙을 하지 아니하거나 또는
      이용을 제한하고 탈퇴시킬 수 있습니다. 이 경우 회사는 회원에게 E-mail, 전화, 팩스, 기타의
      방법을 통해 해지사유를 밝혀 그 시정을 요구하고, 7일 이상으로 정한 기간 내에 이 를 이행하지
      아니한 때에는 계약을 해지합니다. 단, 회사는 당해 회원에게 사전에 해지사유에 대한 의견진술
      기회를 부여할 수 있습니다.
    </p>
    <ol id="l6">
      <li data-list-text="1.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          ID와 PASSWORD 등 회원 고유정보를 타인에게 누설하거나 타인의 ID 및 PASSWORD를 도용한 경우
        </p>
      </li>
      <li data-list-text="2.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          서비스 운영을 고의로 방해하거나 반복적으로 동일한 글을 올리는 등 운영자의 합리적이고
          객관적인 판단에 의해 회원의 자격이 없다고 인정되 는 경우
        </p>
      </li>
      <li data-list-text="3.">
        <p style="padding-left: 14pt; text-indent: 0pt">가입한 성명이 실명이 아닌 경우</p>
      </li>
      <li data-list-text="4.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          동일 이용자가 다른 ID로 이중등록을 한 경우
        </p>
      </li>
      <li data-list-text="5.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          타인의 결제수단(신용카드 / 핸드폰번호)를 도용한 경우
        </p>
      </li>
      <li data-list-text="6.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          공공질서 및 미풍양속에 저해되는 내용을 고의로 유포시킨 경우
        </p>
      </li>
      <li data-list-text="7.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          회원이 국익 또는 사회적 공익을 저해할 목적으로 서비스 이용을 계획 또는 실행하는 경우
        </p>
      </li>
      <li data-list-text="8.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          서비스의 안정적 운영을 방해할 목적으로 정보를 전송하거나 광고성 정 보를 전송하는 경우
        </p>
      </li>
      <li data-list-text="9.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          통신설비의 오동작이나 정보 등의 파괴를 유발시키는 컴퓨터 바이러스 프로그램 등을 유포하는
          경우
        </p>
      </li>
      <li data-list-text="10.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          회사, 다른 회원, 기타 타인의 권리나 명예, 신용 기타 정당한 이익을 침해한 경우
        </p>
      </li>
      <li data-list-text="11.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          회사의 서비스 정보를 이용하여 얻은 정보를 회사의 사전승낙 없이 복 제 또는 유통시키거나
          상업적으로 이용하는 경우
        </p>
      </li>
      <li data-list-text="12.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          회원이 게시판 등에 음란물을 게재하거나 음란사이트를 연결(링크)하는 경우
        </p>
      </li>
      <li data-list-text="13.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          서비스 이용약관을 포함하여 기타 회사가 정한 이용조건 및 관계법령 을 위반하여 더 이상의
          서비스 제공이 어렵다고 판단되는 경우
        </p>
      </li>
      <li data-list-text="14.">
        <p style="padding-left: 35pt; text-indent: -21pt; text-align: left">
          스토킹(stalking) 등 다른 이용자를 괴롭히는 행위를 하는 경우
        </p>
      </li>
      <li data-list-text="15.">
        <p style="padding-top: 2pt; padding-left: 35pt; text-indent: -21pt; text-align: left">
          욕설이나 비방하는 행위를 하는 경우
        </p>
      </li>
      <li data-list-text="16.">
        <p style="padding-top: 2pt; padding-left: 35pt; text-indent: -21pt; text-align: left">
          회사가 신청양식에서 정한 회원정보가 미비한 경우
        </p>
      </li>
      <li data-list-text="17.">
        <p style="padding-top: 3pt; padding-left: 35pt; text-indent: -21pt; text-align: left">
          거래사기 등 범죄행위를 유발한다고 판단되는 경우
        </p>
      </li>
      <li data-list-text="18.">
        <p style="padding-top: 3pt; padding-left: 14pt; text-indent: 0pt">
          이 약관에서 예정하고 있는 거래 이외의 영리를 추구할 목적(직거래 포 함)으로 서비스 가입을
          한 것으로 판단되는 경우
        </p>
      </li>
      <li data-list-text="19.">
        <p style="padding-left: 14pt; text-indent: 0pt">
          기 탈퇴한 회원으로서 관리자의 판단으로 재가입이 웹사이트 운영에 저 해된다고 판단되는 경우
        </p>
      </li>
      <li data-list-text="20.">
        <p style="padding-left: 35pt; text-indent: -21pt; text-align: left">
          기타 이 약관 상 제반 의무를 위반하는 경우
        </p>
      </li>
      <li data-list-text="21.">
        <p style="padding-top: 3pt; padding-left: 35pt; text-indent: -21pt; text-align: left">
          바이러스 유포 가능성이나 이에 대한 의심이 되는 경우
        </p>
      </li>
      <li data-list-text="22.">
        <p style="padding-top: 3pt; padding-left: 35pt; text-indent: -21pt; text-align: left">
          회원이 실제로 거래하고자 하는 의사 없이 거래등록을 한 경우
        </p>
      </li>
    </ol>
    <p
      style="
        padding-top: 3pt;

        text-indent: 0pt; ;
      "
    >
      ③ 제2항에 해당하는 행위를 한 회원은 그로 인해 회사 또는 다른 회원에게 발생한 손해를 배상할
      책임이 있습니다.
    </p>
    <p style="text-indent: 0pt">
      ④ 이용계약의 종료와 관련하여 발생한 손해는 이용계약이 종료된 당해 회 원이 책임을 부담하여야
      합니다. 단, 회사의 고의 또는 과실에 의해 손해가 발생한 경우에는 회사가 손해를 부담합니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제11조(전자메일에 대한 회원의 의무와 책임)
      <span class="p">① 회사는 회원의 전자메일 내 용을 편집하거나 감시하지 않습니다.</span>
    </h3>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt; ;
      "
    >
      ② 회원은 회사의 전자메일을 통해 음란물이나 명예훼손 내용, 서비스와 관 련 없는 스팸메일(spam
      mail), 행운의 편지(chain letters), 피라미드 조직에 가입할 것을 권유하는 메일, 외설 또는
      폭력적인 메시지 / 화상 / 음성 등 타인 에게 피해를 주거나 미풍양속을 해치는 메일을 보내서는
      아니됩니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 제2항을 위반하여 발생되는 모든 책임은 회원에게 있으며, 이 경우 ID 및 PASSWORD 등 개인정보를
      수사기관에 제공할 수 있습니다
    </p>
    <p style="text-indent: 0pt; line-height: 15pt">
      ⑤ SMS, 전화 등 기타 연락수단에 대하여도 상기 조항들의 내용을 준용합니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt; line-height: 114%">
      제12조(게시물 등의 관리)
      <span class="p"
        >① 회사는 회원이 게시하거나 전달하는 서비스의 모든 내용물(회원간 전달되는 내용 포함)이 다음
        각 호에 해당한다고 판단되 는 때에는 사전통지 없이 삭제하거나 이동 또는 등록을 거부할 수
        있습니다.</span
      >
    </h3>
    <ol id="l7">
      <li data-list-text="1.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우
        </p>
      </li>
      <li data-list-text="2.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          공공질서 및 미풍양속에 위반되는 내용인 경우
        </p>
      </li>
      <li data-list-text="3.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          범죄행위에 결부된다고 인정되는 내용인 경우
        </p>
      </li>
      <li data-list-text="4.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          회사 또는 제3자의 지적재산권 등 기타의 권리를 침해하는 내용인 경우
        </p>
      </li>
      <li data-list-text="5.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          회사의 지침에 위배된다고 판단되는 게시물인 경우
        </p>
      </li>
      <li data-list-text="6.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          음란물 또는 음란사이트를 링크 또는 게재하는 경우(음란사이트의 URL 을 게시한 경우 포함)
        </p>
      </li>
      <li data-list-text="7.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          동일 또는 유사한 내용이 반복적으로 게시되는 경우
        </p>
      </li>
      <li data-list-text="8.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          내용이 게시판 성격에 맞지 않거나 건전한 토론 문화를 저해하는 것으 로 판단되는 경우
        </p>
      </li>
      <li data-list-text="9.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          회사 또는 특정인에 대한 인신모독적인 게시물이거나 명예훼손적인 내 용인 경우
        </p>
      </li>
      <li data-list-text="10.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          기타 관계법령 및 회사의 이용약관에 위반된다고 판단되는 경우
        </p>
      </li>
    </ol>
    <p
      style="
        padding-top: 3pt;

        text-indent: 0pt; ;
      "
    >
      ② 회사는 제1항에 해당하는 게시물 이외의 기타 회원들의 콘텐츠에 대해서 도 수정 / 삭제하는 모든
      권한을 가지며, 회원에게 별도의 통지 없이 내용을 삭제하거나 이동 또는 등록을 거절할 수
      있습니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 회원은 개인적인 이익을 위해 회사에 대해 게시물의 추가적 게재 등의 요구를 할 수 없습니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제13조(회원정보의 변경)
      <span class="p"
        >① 회원은 이용신청 시 기재한 사항이 변경되었을 경우, 즉시 해당사항의 수정을 회사에
        요청하여야 합니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt; ;
      "
    >
      ② 회원정보가 변경되었음에도 해당사항의 수정을 요청하지 않음으로써 발 생하는 각종 손해는 회원
      본인이 부담하여야 합니다. 단, 회사의 고의 또는 과실에 의해 손해가 발생한 경우에는 회사가
      손해를 부담합니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt; line-height: 114%">
      제14조(쿠키(Cookie)의 운용 및 활용)
      <span class="p"
        >① 회사는 회원에게 적합하고 유용한 서비스를 제공하기 위하여 회원의 정보를 저장하고 수시로
        불러오는 쿠키 (cookie)를 이용합니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 1pt;

        text-indent: 0pt; ;
      "
    >
      ② 제1항과 관련하여 회원은 쿠키이용에 대한 선택권을 가지며 쿠키의 수신 을 거부하거나 쿠키의
      수신에 대하여 경고하도록 이용하는 컴퓨터 브라우저 의 설정을 변경할 수 있습니다. 단, 쿠키의
      저장을 거부할 경우, 로그인이 필 요한 모든 서비스를 이용할 수 없게 됨으로써 발생되는 문제에
      대한 책임은 회원에게 있습니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제15조(링크 사이트에 대한 책임)
      <span class="p"
        >① 회사는 회원에게 다른 웹사이트 또는 자료에 대한 링크를 제공할 수 있습니다. 이 경우 회사는
        외부사이트 및 자 료에 대한 아무런 통제권이 없으므로 그로부터 제공받은 서비스나 자료의
        정확성, 유용성 등에 대해 책임지지 아니하며, 회사의 개인정보보호정책이 적용되지
        아니합니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt; ;
      "
    >
      ② 회원은 링크된 외부사이트의 서비스나 자료를 신뢰함으로써 또는 이와 관련하여 발생하거나
      발생되었다고 주장하는 어떠한 손해나 손실에 대해서 도 회사에 책임이 없음을 인정하고 이에
      동의합니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt; line-height: 114%">
      제16조(면책)
      <span class="p"
        >① 회사는 다음 각 호의 사유로 인하여 회원에게 발생한 손해 에 대해서는 책임을 지지
        아니합니다. 단, 회사에 책임이 있다고 판단되는 상당한 인과관계가 있는 경우에는 그러하지
        아니합니다.</span
      >
    </h3>
    <ol id="l8">
      <li data-list-text="1.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          통신기기, 회선 및 컴퓨터의 장애나 거래의 폭주 등 부득이한 사정으로 인해 서비스가 제공되지
          못하거나 지연된 경우
        </p>
      </li>
      <li data-list-text="2.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          회원이 ID, PASSWORD 등을 본인의 관리소홀로 인해 제3자에게 누출한 경우
        </p>
      </li>
      <li data-list-text="3.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          회원의 전산조작이나 업무처리의 오류 등으로 인한 경우
        </p>
      </li>
      <li data-list-text="4.">
        <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
          기타 천재지변 등 불가피한 사유로 인한 경우
        </p>
      </li>
    </ol>
    <p
      style="
        padding-top: 3pt;

        text-indent: 0pt; ;
      "
    >
      ② 회사는 회원이 회사의 서비스 제공으로부터 기대되는 이익을 얻지 못하 였거나 서비스 자료에 대한
      취사선택 또는 이용으로 발생하는 손해 등에 대 해서는 책임을 지지 아니합니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 회사는 회원의 귀책사유로 인해 서비스 이용에 장애가 발생한 경우에는 책임을 지지 아니합니다.
    </p>
    <p style="text-indent: 0pt">
      ④ 회사는 회원상호 간 또는 회원과 제3자 상호 간에 서비스를 매개로 하여 물품거래, 직거래 등을 한
      경우에는 그로부터 발생하는 일체의 손해에 대하 여 책임을 지지 아니합니다.
    </p>
    <p style="text-indent: 0pt">
      ⑤ 회사는 회사의 귀책사유 없이 회원 간 또는 회원과 제3자 간에 발생한 일 체의 분쟁에 대하여는
      일절 관여하지 않습니다.
    </p>
    <p style="text-indent: 0pt">
      ⑥ 회사는 서버 등 설비의 관리, 점검, 보수, 교체 또는 소프트웨어의 운용 과정에서 고의 또는
      고의에 준하는 중대한 과실 없이 발생할 수 있는 시스 템의 장애, 제3자의 공격으로 인한 시스템의
      장애, 국내외의 저명한 연구기 관이나 보안관련 업체에 의해 대응방법이 개발되지 아니한 컴퓨터
      바이러스 등의 유포나 기타 회사가 통제할 수 없는 불가항력적 사유로 인한 회원의 손해에 대하여는
      책임을 지지 아니합니다.
    </p>
    <p style="text-indent: 0pt">
      ➀ 제6항의 회원의 손해에는 (1) 회원이 본 서비스를 이용하여 작성하고 있거 나 전송 중이거나
      저장한 게시물, 그에 첨부된 파일, 기타 데이터의 손상 또 는 손실(이하 &quot;데이터의 손상이나
      손실&quot;이라 합니다)로 인한 경제적, 정신적 손해 (2) 이와 같은 데이터의 손상 또는 손실로 인해
      회원이 본 서비스를 이 용하여 수행하고자 한 사실행위 또는 제3자와의 계약 기타의 법률행위 등이
    </p>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt; ;
      "
    >
      불가능해지거나 지연됨으로 인해 회원에게 발생할 수 있는 경제적, 정신적 손해 등이 포함됩니다.
    </p>
    <p style="text-indent: 0pt">
      ⑧ 제6항 및 제7항에도 불구하고 회사가 제공하는 무료서비스의 이용과 관 련하여 회사의 고의 또는
      중대한 과실 없이 발생한 회원의 손해에 대하여는 책임을 지지 아니합니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제17조(저작권의 귀속 및 이용제한)
      <span class="p"
        >① 회사가 작성한 웹화면(문구 및 디자 인)에 관한 저작권, 기타 지적 재산권은 회사에
        귀속됩니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt; ;
      "
    >
      ② 회원은 회사가 제공하는 서비스를 이용함으로써 얻은 정보를 회사의 사 전승낙 없이 출판, 복제,
      방송 및 기타 방법에 의해 유포하거나 제3자에게 이용하게 하여서는 아니됩니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제18조(이용약관의 효력 및 변경)
      <span class="p"
        >① 이용자가 사이트의 서비스를 이용한 경 우에는 이 약관에 동의한 것으로 간주합니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt; ;
      "
    >
      ② 회사는 합리적인 사유가 발생할 경우에는 이 약관을 변경할 수 있으며, 이 경우 적용일자 및
      개정내용을 초기화면 또는 연결화면을 통해 그 적용일 자 7일 이전부터 적용일자 전일까지
      공지합니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 이용약관 변경 시에는 회사가 미리 회원에게 약관변경 내용을 개별적으 로 통지하여 회원이 동의한
      경우나 홈페이지 공지사항을 통해 약관변경 내 용을 7일 전부터 공지하여 동의 여부를 확인한 후
      회원이 의사표시를 하지 않은 경우에는 변경된 약관에 동의한 것으로 간주합니다.
    </p>
    <p style="text-indent: 0pt">
      ④ 변경된 약관에 이의가 있는 회원은 이 약관에서 정한 바에 따라 탈퇴(해 지)할 수 있으며, 약관의
      효력발생일 이후의 서비스 이용은 변경된 약관의 적용을 받습니다.
    </p>
    <p style="text-indent: 0pt">
      ⑤ 이 약관은 회사와 회원 간에 성립되는 이용계약에 관한 기본약정입니다. 회사는 필요한 경우 특정
      서비스에 관하여 적용될 사항(이하 “개별약관”이 라 한다)을 정하여 미리 공지할 수 있습니다.
      회원이 이러한 개별약관에 동 의하고 특정 서비스를 이용하는 경우에는 개별약관이 우선적으로
      적용되며, 이 약관은 보충적인 효력을 갖습니다. 개별약관의 변경에 관하여는 개별약관 에 특별한
      규정이 없는 한 제3항의 내용을 준용합니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt; line-height: 114%">
      제19조(관계법령과의 관계)
      <span class="p"
        >① 이 약관 또는 개별약관에서 정하지 않은 사항 은 전기통신사업법, 전자거래기본법, 정보통신망
        이용촉진 및 정보보호 등에 관한 법률, 전자상거래 등에서의 소비자보호에 관한 법률 등
        관계법령의 규</span
      >
    </h3>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt;
      "
    >
      정과 일반적인 상관례에 의합니다.
    </p>
    <p
      style="
        padding-top: 3pt;

        text-indent: 0pt; ;
      "
    >
      ② 회원은 회사가 제공하는 서비스를 이용함에 있어 전자상거래 등에서의 소비자보호에 관한 법률,
      전자거래기본법, 소비자보호법, 표시광고의 공정화 에 관한 법률, 정보통신망 이용촉진 및 정보보호
      등에 관한 법률 등 관계법 령을 준수하여야 하며, 이 약관의 규정을 들어 관계법령 위반에 대한
      면책을 주장할 수 없습니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt; line-height: 114%">
      제20조(약관 위반 시 책임)
      <span class="p"
        >회사와 회원은 이 약관 및 동의서를 위반함으로 써 발생하는 모든 책임을 각자 부담하며, 이로
        인해 상대방에게 손해를 입힌 경우에는 지체없이 배상하여야 합니다.</span
      >
    </h3>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제21조(제휴사 또는 광고주와의 거래)
      <span class="p"
        >① 회원은 서비스 이용 시 노출되는 제휴사를 포함한 회사의 광고 게재에 대해 동의한 것으로
        봅니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt; ;
      "
    >
      ② 회사는 서비스 상 게재되어 있거나 본 서비스를 통한 제휴사 등의 판촉 활동에 회원이 참여하거나
      교신 또는 거래를 함으로써 발생하는 손실과 손 해에 대해 일체의 책임을 지지 아니합니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 회원은 서비스 내에 포함되어 있는 링크를 통해 다른 웹사이트로 옮겨갈 경우, 회사는 해당
      사이트에서 제공하는 정보내용 및 이로 인한 손해 등에 대해 책임을 지지 아니합니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제22조(정보제공)
      <span class="p"
        >① 회사는 회원의 서비스 이용에 필요가 있다고 인정되는 각종 정보 및 광고를 전자우편 또는
        서신우편 등의 방법으로 회원에게 전송 (또는 제공)할 수 있으며, 회원은 이를 원치 않을 경우
        수신거부를 요청할 수 있습니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 3pt;

        text-indent: 0pt; ;
      "
    >
      ② 전자우편 수신을 거부한 경우에도 이 약관(개별서비스 이용약관 포함), 개 인정보보호정책, 기타
      중대한 영업정책의 변경 등 회원이 반드시 알고 있어 야 하는 공지사항이 있는 경우, 수신거부와
      관계없이 공지메일을 발송할 수 있습니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 회사는 서비스 개선 및 회원 대상의 서비스 소개 등의 목적으로 회원의 동의 하에 추가적인
      개인정보를 요구할 수 있습니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제23조(수수료 등)
      <span class="p"
        >① 회사는 서비스 이용에 대한 대가로서 별도로 정한 수 수료 부과기준에 따라 수수료를 징수할 수
        있습니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt;
      "
    >
      ② 약정상환일까지 약정한 원리금을 상환하지 아니하는 경우에는 익일부터
    </p>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt;
      "
    >
      “금전소비대차계약”에 의거한 연체이자율이 적용됩니다.
    </p>
    <p
      style="
        padding-top: 3pt;

        text-indent: 0pt; ;
      "
    >
      ③ 회사는 회원의 입금 또는 출금과 관련하여 계좌이체에 의해 발생하는 출 입금 이체수수료를
      회원에게 부과할 수 있습니다. 단, 회사의 정책에 따라 이체수수료 금액을 할인 또는 면제할 수
      있습니다.
    </p>
    <p style="text-indent: 0pt">
      ④ 회사는 수수료의 추가 및 폐지, 수수료율 변경을 할 수 있으며, 수수료 개정 시에는 적용일자 및
      개정사유를 명시하여 그 적용일 7일 이전부터 적 용일 전일까지 사이트 화면에 게시하거나 기타의
      방법으로 회원에게 공지합 니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제24조(채권추심의 위임 등)
      <span class="p"
        >① 회사는 다음 각 호에 해당하는 경우에는 회 사가 지정하는 업체에 채권추심을 위임할 수
        있습니다.</span
      >
    </h3>
    <ol id="l9">
      <li data-list-text="1.">
        <p style="padding-top: 3pt; text-indent: 0pt">연체발생 60일 이상에 해당하는 경우</p>
      </li>
      <li data-list-text="2.">
        <p style="padding-top: 3pt; text-indent: 0pt">
          수차례 유선상의 연락에도 불구하고 연락이 되지 않거나 채무자가 직접 채권상환의지가 없음을
          명확하게 전달하여, 현장방문 진행 등 채권의 보전 을 위하여 반드시 필요하다고 회사가
          판단하는 경우
        </p>
      </li>
      <li data-list-text="3.">
        <p style="text-indent: 0pt">
          온라인연계 대출계약 약관에서 규정한 “기한의 이익상실” 사유에 해 당하는 경우
        </p>
      </li>
    </ol>
    <p style="text-indent: 0pt">
      ② 제1항의 규정에 의해 채권추심을 위임하는 경우, 채권회수금액의 일정비 율에 해당하는
      추심성공수수료를 회사가 위임한 업체에 지불할 수 있으며, 이로 인해 투자자에게 투자금의 손실이
      발생할 수 있습니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 법적 조치에 소요되는 비용이 추가적으로 발생할 수 있으며, 대출채권에 대한 원활한 회수를
      위하여 투자자의 동의 없이 회사의 재량으로 감액 또는 면제조치를 할 수 있습니다.
    </p>
    <p style="text-indent: 0pt; line-height: 15pt">
      ④ 상기의 사유 등으로 인해 투자자에게 손실이 발생할 수 있습니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제25조(채권매각)
      <span class="p"
        >① 투자자가 원리금수취권을 보유하고 있는 해당 대출건이 연체 또는 기한의 이익상실 사유가
        발생하거나 해당 대출건의 채무자가 약 정만기상환일에 약정산환금액을 모두 상환하지 못한 경우
        회사는 해당 채권 을 신용회복기금 또는 회사가 지정하는 업체에 매각할 수 있습니다.</span
      >
    </h3>
    <p
      style="
        padding-top: 3pt;

        text-indent: 0pt; ;
      "
    >
      ② 채권매각은 해당 채권 투자자들의 투자금 손실을 최소화하는 방향으로 진행하며, 투자자들에게
      채권매각 진행에 관한 안내를 합니다.
    </p>
    <p style="text-indent: 0pt">
      ③ 이 경우 회사는 해당 채권의 매각금액에 소요되는 비용을 제한 잔여금을 자금출연 비율에 맞게
      투자자에게 분배하며, 투자자의 원금손실이 발생할 수 있습니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제26조(분쟁조정 및 관할법원) <span class="p">① 회사 및 회원은 회원정보에 관한 분쟁이</span>
    </h3>
    <p
      style="
        padding-top: 1pt;

        text-indent: 0pt; ;
      "
    >
      발생한 경우 신속하고도 효과적인 분쟁해결을 위해 정보통신망 이용촉진 및 정보보호 등에 관한
      법률에 의해 설치된 개인정보분쟁조정위원회에 분쟁조 정을 신청할 수 있습니다.
    </p>
    <p style="text-indent: 0pt">
      ② 서비스 이용과 관련하여 발생한 분쟁에 대해 소송이 제기될 경우, 관할법 원은 제소 당시 회원의
      주소에 의하며, 주소가 없는 경우에는 거소를 관할하 는 지방법원의 전속관할로 합니다. 단, 제소
      당시 이용자의 주소 또는 거소 가 분명하지 않거나 외국거주자의 경우에는 민사소송법상의
      관할법원에 제 기합니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h3 style="text-indent: 0pt">
      제27조(투자자 보호)
      <span class="p">① 투자자의 투자한도는 관계법령, 감독규정, 감독기관 의 지침을 따릅니다.</span>
    </h3>
    <p
      style="
        padding-top: 2pt;

        text-indent: 0pt; ;
      "
    >
      ② 제1항의 투자한도는 관계법령, 감독규정, 감독기관의 지침에 따라 변경될 수 있습니다. 이 경우
      회사는 이러한 사실을 홈페이지에 공지하고 회원에게 E-mai, SNS 등의 방법으로 고지합니다.
    </p>
    <p style="text-indent: 0pt"><br /></p>
    <h2 style="text-indent: 0pt; text-align: center">부 칙</h2>
    <p style="text-indent: 0pt"><br /></p>
    <p style="text-indent: 0pt; text-align: justify">이 약관은 2021년 11월 1일부터 적용합니다.</p>

    <p>&nbsp;</p>
    <br />
    <p>&nbsp;</p>
    <br />
    <p>&nbsp;</p>
    <br />
    <p>&nbsp;</p>
    <br />
    <p>&nbsp;</p>
    <br />
  </div>
</template>

<style lang="scss" scoped>
.ServiceTerm {
  font-weight: 500;
  font-size: 15px;
  line-height: 1.47;
  letter-spacing: -0.3px;
  margin-top: 14px;
  margin-left: 14px;
  margin-right: 14px;
  word-break: break-all;
  white-space: pre-line;
}
h1 {
  color: black;
  font-family: 'Malgun Gothic', sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 18pt;
}
h3 {
  color: black;
  font-family: 'Malgun Gothic', sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 12pt;
}
.p,
p {
  color: black;
  font-family: Dotum, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
  margin: 0pt;
}
.a {
  color: black;
  font-family: Dotum, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
.s1 {
  color: black;
  font-family: 'Microsoft Sans Serif', sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
h2 {
  color: black;
  font-family: 'Malgun Gothic', sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 13pt;
}
li {
  display: block;
}
#l1 {
  padding-left: 0pt;
  counter-reset: c1 1;
}
#l1 > li > *:first-child:before {
  counter-increment: c1;
  content: counter(c1, decimal) '. ';
  color: black;
  font-family: Dotum, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
#l1 > li:first-child > *:first-child:before {
  counter-increment: c1 0;
}
li {
  display: block;
}
#l2 {
  padding-left: 0pt;
  counter-reset: d1 1;
}
#l2 > li > *:first-child:before {
  counter-increment: d1;
  content: counter(d1, decimal) '. ';
  color: black;
  font-family: Dotum, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
#l2 > li:first-child > *:first-child:before {
  counter-increment: d1 0;
}
li {
  display: block;
}
#l3 {
  padding-left: 0pt;
  counter-reset: e1 1;
}
#l3 > li > *:first-child:before {
  counter-increment: e1;
  content: counter(e1, decimal) '. ';
  color: black;
  font-family: Dotum, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
#l3 > li:first-child > *:first-child:before {
  counter-increment: e1 0;
}
li {
  display: block;
}
#l4 {
  padding-left: 0pt;
  counter-reset: f1 1;
}
#l4 > li > *:first-child:before {
  counter-increment: f1;
  content: counter(f1, decimal) '. ';
  color: black;
  font-family: Dotum, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
#l4 > li:first-child > *:first-child:before {
  counter-increment: f1 0;
}
li {
  display: block;
}
#l5 {
  padding-left: 0pt;
  counter-reset: g1 1;
}
#l5 > li > *:first-child:before {
  counter-increment: g1;
  content: counter(g1, decimal) '. ';
  color: black;
  font-family: Dotum, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
#l5 > li:first-child > *:first-child:before {
  counter-increment: g1 0;
}
li {
  display: block;
}
#l6 {
  padding-left: 0pt;
  counter-reset: h1 1;
}
#l6 > li > *:first-child:before {
  counter-increment: h1;
  content: counter(h1, decimal) '. ';
  color: black;
  font-family: Dotum, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
#l6 > li:first-child > *:first-child:before {
  counter-increment: h1 0;
}
li {
  display: block;
}
#l7 {
  padding-left: 0pt;
  counter-reset: i1 1;
}
#l7 > li > *:first-child:before {
  counter-increment: i1;
  content: counter(i1, decimal) '. ';
  color: black;
  font-family: Dotum, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
#l7 > li:first-child > *:first-child:before {
  counter-increment: i1 0;
}
li {
  display: block;
}
#l8 {
  padding-left: 0pt;
  counter-reset: j1 1;
}
#l8 > li > *:first-child:before {
  counter-increment: j1;
  content: counter(j1, decimal) '. ';
  color: black;
  font-family: Dotum, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
#l8 > li:first-child > *:first-child:before {
  counter-increment: j1 0;
}
li {
  display: block;
}
#l9 {
  padding-left: 0pt;
  counter-reset: k1 1;
}
#l9 > li > *:first-child:before {
  counter-increment: k1;
  content: counter(k1, decimal) '. ';
  color: black;
  font-family: Dotum, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}
#l9 > li:first-child > *:first-child:before {
  counter-increment: k1 0;
}
</style>

<script>
export default {
  name: 'ServiceTerm',
  data() {
    return {}
  },
  created() {
    this.$store.commit('ui/headerTitle', '서비스 이용약관')
  },
}
</script>
